<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 class="font-family005">Police</h2>
            <ul class="font-family005">
                <li><a routerLink="/"><i class="bx bx-home"></i> Home</a></li>
                <li class="active">Police</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Blog Details Area -->
<div class="blog-details-area py-5">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-7">
                <div class="blog-details-content">
                    <div class="blog-top-content">
                        <div class="news-content">
                            <h3 class="font-family005">SMART KAVALAR, FIELD POLICING APP</h3>
                            <p class="font-family004 mb-2">Tracking of Field Executives in real time by Higher officials for Reporting. Creation of
                                Data bank and Geo-tagging to enable the location importance. API Integration with
                                external Databases like Vahan , Sarathi etc. The Main Functionalities are,
                            </p>
                            <ul class="font-family004 px-3">
                                <li><i class="bx bx-check-double text-c01"></i> Beat Creation /Allocation / Self assigned</li>
                                <li><i class="bx bx-check-double text-c01"></i> Perform the Beat , Field Duties & General Tasks</li>
                                <li><i class="bx bx-check-double text-c01"></i> Monitoring & Live Beat Tracking</li>
                                <li><i class="bx bx-check-double text-c01"></i> Generating Customized Reports</li>
                                <li><i class="bx bx-check-double text-c01"></i> SoS, Chat & Broadcast</li>
                            </ul>
                        </div>
                        <div class="news-content pt-3">
                            <h3 class="font-family005">Highlights of SMART KAVALAR</h3>
                            <p class="font-family004">Holds 20,000 concurrent users and Total users experience above 75,000. Utilization of
                                Google Map API above 3Lack server request per day. Geo location tagging of prime
                                localities like villages, ward, ATM, School, Temple, Govt offices and other important
                                landmarks are covered. Report generation in varied customization styles is enabled.
                                External plugins and API integration with flawless application flow is implemented.
                                Supports both web and Mobile platforms with elegant user interfaces.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-5">
                <div class="row match-height">
                    <div class="col-12 pb-2">
                        <div class="fix">
                            <a routerLink="/blog-details">
                                <img src="assets/img/blog/blog-4.jpg" alt="Image" class="img-thumbnail">
                            </a>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="fix">
                            <a routerLink="/blog-details">
                                <img src="assets/img/police1.jpg" alt="Image" class="img-thumbnail">
                            </a>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="fix">
                            <a routerLink="/blog-details">
                                <img src="assets/img/police2.jpg" alt="Image" class="img-thumbnail">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Blog Details Area -->